/* eslint-disable */

export const enum ExternalVideoCategory {
  marketing = 1,
  tutorial = 2,
  quarterly = 3,
}
